module.exports = __webpack_public_path__ + "img/Red_Mixed.af52379b.png";